module.exports = __webpack_public_path__ + "static/media/Resume.e8506e8e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/Resume.pdf
// module id = 53
// module chunks = 0